import axios from 'axios'
import { GET_USER, LOGOUT } from '@/assets/scripts/api'
import Cookies from 'js-cookie'

const state = {
  registrationInfo: {},
  self: {},
  fillUserInfo: {},
  familyEdit: {},
  medicalCard: {}
}

const mutations = {
  setSelf (state, data) {
    state.self = data
  },
  setFamilyEdit (state, data) {
    state.familyEdit = data
  },
  setFillUserInfo (state, data) {
    state.fillUserInfo = data
  },
  setMedicalCard (state, data) {
    state.medicalCard = data
  },
  /**
   *
   * 保存个体化问诊登记人信息
   * @param state
   * @param data  登记人信息
   */
  setRegistrationInfo (state, data) {
    state.registrationInfo = data
  }
}

const getters = {
  getSelf: state => {
    return state.self
  }
}
const actions = {
  getUserData: async function ({commit, state}) {
    if (!state.self || Object.keys(state.self).length === 0) {
      let {data} = await axios.get(GET_USER)
      commit('setSelf', data.data)
      return true
    }
  },
  replaceUserData: async function ({commit, state, dispatch}) {
    commit('setSelf', {})
    await dispatch('getUserData')
  },
  clearUserData ({commit}) {
    axios.get(LOGOUT)
    Cookies.set('51jk.TK', '')
    Cookies.set('51jk.CID', '')
    commit('setSelf', {})
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
